var map = {
	"./image/activity_1.png": "63e8",
	"./image/activity_2.png": "05f5",
	"./image/activity_3.png": "1180",
	"./image/banner.png": "e442",
	"./image/domain/img-001.jpg": "edd1",
	"./image/domain/img-002.jpg": "b80f",
	"./image/domain/img-003.jpg": "eabb",
	"./image/domain/img-004.jpg": "73e1",
	"./image/domain/img-005.jpg": "2f4b",
	"./image/domain/img-006.jpg": "8ee1",
	"./image/domain/img-007.jpg": "ae6b",
	"./image/domain/img-008.jpg": "eac5",
	"./image/domain/img-009.jpg": "d8d9",
	"./image/domain/img-010.jpg": "39fe",
	"./image/domain/img-011.jpg": "4c7f",
	"./image/domain/img-012.jpg": "c9e5",
	"./image/domain/img-013.jpg": "a98d",
	"./image/domain/img-014.jpg": "db05",
	"./image/domain/img-015.jpg": "857b",
	"./image/domain/img-016.jpg": "2d29",
	"./image/domain/img-017.jpg": "47f5",
	"./image/domain/img-018.jpg": "ef7b",
	"./image/icon-logo-xl.png": "ad38",
	"./image/icon-logo.png": "9b4e",
	"./image/icon-mpai-long-logo.png": "9894",
	"./image/img-about-us.jpg": "c3a5",
	"./image/img-about-us.png": "a26a",
	"./image/img-arrow.gif": "b125",
	"./image/img-case-001.png": "3c6b",
	"./image/img-case-002.png": "5fb5",
	"./image/img-case-003.png": "b56f",
	"./image/img-code.jpg": "a086",
	"./image/img-download-pc.png": "1ed3",
	"./image/img-index-logo.png": "acd6",
	"./image/img-index.gif": "bb10",
	"./image/img-notice.png": "69ef",
	"./image/img-public-security.png": "93a6",
	"./image/introduce/img-introduce-001.png": "dfbf",
	"./image/introduce/img-introduce-002.png": "8e2b",
	"./image/introduce/img-introduce-003.png": "e0f5",
	"./image/introduce/img-introduce-004.png": "0cf0",
	"./image/introduce/img-introduce-005.png": "d3d4",
	"./image/introduce/img-introduce-006.png": "1cac",
	"./image/mp-logo.png": "255d",
	"./image/phone_1.png": "04ae",
	"./image/phone_2.png": "da40",
	"./image/phone_3.png": "b2ae",
	"./image/phone_4.png": "36d2",
	"./image/recommend_bg.png": "b0fe",
	"./image/video-001.mp4": "8814",
	"./image/video-002.mp4": "57b9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "caba";